export default {
  addNewCard: 'Добавить карту',
  isDefault: 'основная',
  doDefault: 'Сделать основной',
  delete: 'Удалить',
  confirm: 'Вы действительно хотите удалить эту карту?',
  setDefault: 'Сделать основной',
}